export default {"src":"/_next/static/media/blue-blob-mask-1.c63343b5.svg","height":112,"width":86,"blurWidth":0,"blurHeight":0};